import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  projects: [
    "Scoreboard",
    "Flight Booking",
    "Product Cart",
    "Book Store",
    "Blog Application",
    "Job Finder",
  ],
};

const projectsSlice = createSlice({
  name: "projects",
  initialState,
  reducers: {
    addProject: (state, action) => {
      state.projects.push(action.payload);
    },
    removeProject: (state, action) => {
      state.projects = state.projects.filter(
        (project) => project !== action.payload
      );
    },
  },
});

export const { addProject, removeProject } = projectsSlice.actions;
export default projectsSlice.reducer;
